<template>
  <div v-if="meetingInfo">
    <b-steps
      v-model="step"
      size="is-small"
      type="is-primary"
      :has-navigation="false"
      animated
    >
      <b-step-item
        :clickable="true"
        value="/meetings/attendee-details"
        label="Attendee Details"
        icon="account-key"
      ></b-step-item>

      <b-step-item
        :clickable="profileSubmitted"
        value="/meetings/survey"
        label="Survey"
        icon="account"
        v-if="meetingInfo.meeting.survey"
      ></b-step-item>

      <b-step-item
        :clickable="
          profileSubmitted && surveyCompleted && !meetingInfo.pnrRecordLocator
        "
        value="/meetings/flights"
        v-if="meetingInfo.meeting.useFlightTool"
        label="Flight"
        icon="airplane"
      />

      <b-step-item
        :clickable="
          profileSubmitted && surveyCompleted && !meetingInfo.pnrRecordLocator
        "
        value="/meetings/hotels"
        v-if="meetingInfo.meeting.useHotelTool"
        label="Hotel"
        icon="bed"
      />

      <b-step-item
        :clickable="
          profileSubmitted && surveyCompleted && !meetingInfo.pnrRecordLocator
        "
        value="/meetings/cars"
        v-if="meetingInfo.meeting.useCarTool"
        label="Car"
        icon="car"
      />

      <b-step-item
        :clickable="
          (result.flight.journeys || meetingInfo.noAirTravelRequired) &&
            (result.car.pickupInfo || meetingInfo.noCarRentalRequired) &&
            (result.hotel.hotelCode || meetingInfo.noHotelRequired)
        "
        value="/meetings/summary"
        label="Checkout"
        icon="cart"
      ></b-step-item>
    </b-steps>
  </div>
</template>

<script>
import meetingsMixin from "@/mixins/meetingsMixin";
export default {
  name: "MeetingSteps",
  mixins: [meetingsMixin],
  data: function() {
    return {
      activeStep: "/meetings/attendee-details",
    };
  },
  props: {},

  watch: {
    $route(to, from) {
      console.log("route watched: ", this.$route.path);
      this.setStep(this.$route.path);
    },
  },
  computed: {
    result() {
      return this.$store.state.bookTravel.result;
    },
    surveyCompleted() {
      return this.$store.state.meetings.meetingSurveySet;
    },
    profileSubmitted() {
      return this.$store.state.meetings.meetingProfileSet;
    },
    step: {
      get() {
        return this.activeStep;
      },
      set(val) {
        this.$router.push({ path: val });
      },
    },
  },
  methods: {
    // set the activeStep based on the current route
    setStep(path) {
      let step = path.split("/")[2];
      if (this.meetingSteps.includes(step)) {
        this.activeStep = "/meetings/" + step;
      }
    },
  },
  mounted() {
    console.log("route mounted: ", this.$route.path);
    this.setStep(this.$route.path);
  },
};
</script>

<style lang="scss" scoped>
// mobile
@media screen and (max-width: 1023px) {
  .profile {
    margin: auto;
  }
}
// pc
@media screen and (min-width: 1024px) {
  .profile {
    margin: auto;
  }
}
</style>
